import { render, staticRenderFns } from "./PleaseChangeShiIft.vue?vue&type=template&id=38f340ca&scoped=true"
import script from "./PleaseChangeShiIft.vue?vue&type=script&lang=js"
export * from "./PleaseChangeShiIft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f340ca",
  null
  
)

export default component.exports